/* OBC: sold-out product cards
   - Greys out the card image with "Sold Out" across the middle (CSS below, keyed off the theme's own sold-out badge)
   - Hides the theme's sold-out badge, which Variantify clones drop on top of the product title
   - Crosses out every sold-out colourway swatch on every card (uses the theme's own .sold-out swatch style)
   - "no restocks" bubble on every 2027 product card */
(function () {
  var css =
    '.product-grid-item .product-badge__item--sold{display:none!important}' +
    '.product-grid-item:has(.product-badge__item--sold) .product__media__container::after{' +
      'content:"Sold Out";position:absolute;inset:0;z-index:3;display:flex;align-items:center;justify-content:center;' +
      'background:rgba(255,255,255,.55);color:#4a4a4a;font-family:var(--FONT-STACK-BODY,serif);' +
      'font-size:clamp(14px,1.6vw,20px);font-weight:600;letter-spacing:.12em;text-transform:uppercase;pointer-events:none}' +
    // theme's cross line is black, which vanishes on dark swatches - wash the swatch first
    '.product-grid-item .swatch__button.sold-out .swatch__label{box-shadow:inset 0 0 0 30px rgba(255,255,255,.6)}' +
    '.product-grid-item .swatch__button.sold-out .swatch__label::after{background-color:#1a1a1a;z-index:3}' +
    // "no restocks" bubble on every 2027 product card (handles all start 2027-)
    '.product-grid-item:has(a[href*="/products/2027-"]) .product__media__container::before{' +
      'content:"no restocks";position:absolute;top:12px;left:12px;z-index:4;padding:5px 12px 6px;border-radius:999px;' +
      'background:rgba(220,218,212,.85);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);color:#1a1a1a;' +
      'font-family:var(--FONT-STACK-BODY,serif);font-style:italic;font-size:13px;line-height:1;letter-spacing:.01em;pointer-events:none}';
  var style = document.createElement('style');
  style.id = 'obc-sold-out-cards';
  style.textContent = css;
  document.head.appendChild(style);

  var cache = {};
  function availability(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : { variants: [] }; })
        .then(function (p) {
          var map = {};
          (p.variants || []).forEach(function (v) { map[v.id] = v.available; });
          return map;
        })
        .catch(function () { return {}; });
    }
    return cache[handle];
  }

  function markSwatches() {
    document.querySelectorAll('.product-grid-item [data-swatch-handle]').forEach(function (group) {
      availability(group.getAttribute('data-swatch-handle')).then(function (map) {
        group.querySelectorAll('.swatch__button').forEach(function (btn) {
          var label = btn.querySelector('[data-swatch-variant]');
          if (!label) return;
          var id = label.getAttribute('data-swatch-variant');
          if (map[id] === false) btn.classList.add('sold-out');
        });
      });
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(markSwatches, 150); }

  function start() {
    markSwatches();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();